
export default function HeroSection() {
  return (
    <section className="relative pt-32 pb-20 px-6 bg-gradient-to-b from-emerald-50 via-white to-stone-50">
      <div className="max-w-4xl mx-auto text-center">
        <div className="inline-flex items-center gap-2 bg-emerald-100 text-emerald-800 px-4 py-2 rounded-full text-sm font-bold mb-6">
          <i className="ri-flashlight-line"></i>
          Instant Pricing
        </div>

        <h1 className="text-4xl md:text-5xl font-bold mb-6 tracking-wide">
          Get Your Quote in Minutes
        </h1>

        <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto leading-relaxed">
          Enter your field location, confirm acreage, and see transparent pricing based on field
          complexity, seasonality, and service options. No sales calls required.
        </p>

        <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-gray-600">
          <div className="flex items-center gap-2">
            <i className="ri-map-pin-line text-emerald-700"></i>
            Map-verified acreage
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-calculator-line text-emerald-700"></i>
            Transparent pricing
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-time-line text-emerald-700"></i>
            Instant results
          </div>
        </div>
      </div>
    </section>
  );
}
